import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  LICENSE_PLATES_REPOSITORY,
  LicensePlatesRepository
} from '@app/domain/repositories/ptrab/license-plates/license-plates.repository.contract';
import { VehicleType } from '@app/entities/enums/ptrab/vehicle-type.enum';
import { LicensePlateRequest, LicensePlates } from '@app/entities/models/ptrab/license-plates/license-plates.model';

import { LicensePlatesUseCases } from './license-plates.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class LicensePlatesUseCasesImpl implements LicensePlatesUseCases {
  #licensePlatesRepository: LicensePlatesRepository = inject(LICENSE_PLATES_REPOSITORY);

  getLicensePlates(): Observable<LicensePlates> {
    return this.#licensePlatesRepository.getLicensePlates();
  }

  createLicensePlate(licensePlate: LicensePlateRequest, vehicleType: VehicleType): Observable<object> {
    return this.#licensePlatesRepository.createLicensePlate(licensePlate, vehicleType);
  }

  updateLicensePlate(
    licensePlate: LicensePlateRequest,
    vehicleType: VehicleType,
    vehicleId: string
  ): Observable<object> {
    return this.#licensePlatesRepository.updateLicensePlate(licensePlate, vehicleType, vehicleId);
  }

  deleteLicensePlate(vehicleType: VehicleType, vehicleId: string): Observable<object> {
    return this.#licensePlatesRepository.deleteLicensePlate(vehicleType, vehicleId);
  }
}
